import "Common/paginator";

let foundListingProductsLocale, listingProductsLocale;
const defaultView = "grid";

const lang = document.querySelector("html").getAttribute("lang");
import(`Locale/${lang}.json`).then((module) => {
    foundListingProductsLocale = module.Catalog.Listing.FoundProducts;
    listingProductsLocale = module.Catalog.Listing.Products;
});

const $sort = $("#filter-sort"),
    $fakeSortSelect = $(".js-fake-sort-select"),
    $view = $("#filter-view"),
    $fakeView = $(".js-fake-view");

const changeFakeSortButton = (value) => {
    $fakeSortSelect.val(value);
};

$(function () {
    // fake sort
    const sortValue = $sort.val();

    if (sortValue) {
        changeFakeSortButton(sortValue);
    }

    $fakeSortSelect.on("change", function () {
        const value = $(this).val();

        changeFakeSortButton(value);
        $sort.val(value).trigger("change");
    });
});

rEvent.on("Listing.fetchedData", function (data) {
    const $listingCount = $(".js-listing-count");

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;
            const isCountDesktop = $countElem.data("listing-count") === "desktop";

            countHtml = `${
                isCountDesktop
                    ? Format.plural(
                          foundListingProductsLocale.single,
                          foundListingProductsLocale.twoToFour,
                          foundListingProductsLocale.plural,
                          data.count
                      )
                    : ""
            }
                    ${isCountDesktop ? `<span class="sc-text">${data.count}</span>` : data.count}
                    ${Format.plural(
                        listingProductsLocale.single,
                        listingProductsLocale.twoToFour,
                        listingProductsLocale.plural,
                        data.count
                    )}`;

            if ($countElem.hasAttr("data-template")) {
                countHtml = $countElem.data("template").replace(":value:", countHtml);
            }

            $countElem.html(countHtml);
        });
    }
});

const changeListingLayout = () => {
    let viewValue = getCookie("listingView");

    if (viewValue) {
        $(".js-fake-view#" + viewValue).addClass("is-active");
    } else {
        $(".js-fake-view#" + defaultView).addClass("is-active");
    }

    $fakeView.on("click", function () {
        viewValue = $(this).data("value");

        $view.val(viewValue).change();
    });

    rEvent.on("Listing.changeView", function () {
        const $view = $("#filter-view"),
            value = $view.val();

        $(".js-fake-view").removeClass("is-active");
        $(".js-fake-view#" + value).addClass("is-active");

        $(".products").removeClass("products--row").removeClass("products--grid");
        $(".products").addClass("products--" + value);

        $(".products .js-thumb").removeClass("is-row").removeClass("is-grid");
        $(".products .js-thumb").addClass("is-" + value);
    });
};

changeListingLayout();
